import { Breadcrumbs } from "components/breadcrumbs";
import { CreateAccountForm } from "./components";

export const CreateOrgAccount : React.FC = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create new Org's Account" />
      <CreateAccountForm />
    </div>
  );
}